import React, { useState } from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

const templates = [
  {
    id: "investor-summary",
    label: "Investor Summary",
    description: "1-page executive overview with key metrics and ROI projections",
    icon: "FileText",
    pages: 1,
  },
  {
    id: "detailed-analysis",
    label: "Detailed Analysis",
    description: "Comprehensive 8-page report with cash flow, comparables, and market data",
    icon: "BookOpen",
    pages: 8,
  },
  {
    id: "client-presentation",
    label: "Client Presentation",
    description: "Slide-ready format with charts and visual investment highlights",
    icon: "Presentation",
    pages: 12,
  },
  {
    id: "tax-planning",
    label: "Tax Planning Report",
    description: "Depreciation schedules, tax benefits, and 1031 exchange analysis",
    icon: "Receipt",
    pages: 5,
  },
];

export default function ReportGenerator() {
  const [selected, setSelected] = useState("investor-summary");
  const [generating, setGenerating] = useState(false);
  const [generated, setGenerated] = useState(false);

  const handleGenerate = async () => {
    setGenerating(true);
    setGenerated(false);
    await new Promise((r) => setTimeout(r, 2000));
    setGenerating(false);
    setGenerated(true);
  };

  return (
    <div className="card-base flex flex-col gap-5">
      <div>
        <h3 className="font-heading font-semibold text-base text-foreground">
          Report Generation
        </h3>
        <p className="text-xs font-caption text-muted-foreground mt-0.5">
          Generate investor-ready reports and presentations
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {templates?.map((t) => (
          <button
            key={t?.id}
            onClick={() => { setSelected(t?.id); setGenerated(false); }}
            className={`text-left p-4 rounded-xl border transition-standard ${
              selected === t?.id
                ? "border-primary bg-primary/5" :"border-border bg-background hover:bg-muted"
            }`}
          >
            <div className="flex items-start gap-3">
              <div
                className={`flex items-center justify-center w-9 h-9 rounded-lg flex-shrink-0 ${
                  selected === t?.id ? "bg-primary/10" : "bg-muted"
                }`}
              >
                <Icon
                  name={t?.icon}
                  size={18}
                  color={selected === t?.id ? "var(--color-primary)" : "var(--color-muted-foreground)"}
                />
              </div>
              <div className="min-w-0">
                <p className={`text-sm font-heading font-semibold ${selected === t?.id ? "text-primary" : "text-foreground"}`}>
                  {t?.label}
                </p>
                <p className="text-xs font-caption text-muted-foreground mt-0.5 line-clamp-2">
                  {t?.description}
                </p>
                <p className="text-xs font-caption text-muted-foreground mt-1">
                  {t?.pages} page{t?.pages > 1 ? "s" : ""}
                </p>
              </div>
            </div>
          </button>
        ))}
      </div>
      <div className="flex items-center gap-3 flex-wrap">
        <Button
          variant="default"
          iconName={generating ? "Loader2" : "FileDown"}
          iconPosition="left"
          iconSize={16}
          loading={generating}
          onClick={handleGenerate}
        >
          {generating ? "Generating..." : "Generate Report"}
        </Button>
        {generated && (
          <div className="flex items-center gap-2 text-sm font-caption text-success">
            <Icon name="CheckCircle" size={16} color="var(--color-success)" />
            Report ready — click to download
          </div>
        )}
      </div>
    </div>
  );
}